<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',

  created(){
    this.$nextTick(() => {})
    
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem("store"))))
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    window.addEventListener("beforeunload",()=>{
        sessionStorage.setItem("store",JSON.stringify(this.$store.state))
    })
  }
}
</script>

<style lang="less">
@import "@/untils/public.less";
* {
  margin: 0;
  padding: 0;
  // touch-action: pan-y;
}
html, body, #app {
  width: 100%;
  height: 100%;
  min-width: 900px;
}
.app-main {
  width: 100%;
  height: calc(100% - 60px);
  background: #fff;
  // border-radius: 5px;
  padding:0 30px 15px;
  box-sizing: border-box;
  overflow: auto;
  position: relative;
  .top-bar {
    padding: 0 0 20px;
    position: sticky;
    top: 0;
    left: 0;
    background: #fff;
    z-index: 666;
    .search-input {
      width: 200px;
      margin-right: 10px;
    }
  }
  .m-pagination{
    padding: 10px 10px 10px 0 !important;
  }
}
.el-message{margin-top:0% !important;font-size:18px;height:70px !important;
  .el-message__icon{font-size:20px;line-height:20px}
  .el-message__content{font-size:18px;text-align: center;}
}
.table-btns {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /deep/ .el-button + .el-button {
    margin: 8px 0 0 0;
  }
}
#nprogress .bar {
  background: #ffd04b !important;
  height: 5px  !important;
  border-radius: 5px;
}
#nprogress .peg {
  box-shadow: none !important;
}
</style>
